import React, { useState, useEffect } from "react";
import { Card, Button, Form, Navbar, Alert } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { signin } from "../helpers/auth";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [buttonActivated, setButtonActivated] = useState(false);


    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await signin(email, password);
        } catch (error) {
            setError("Une erreur s'est produite.");
        }
    }

    const handleChange = (event) => {
        if (event.target.name === "email") {
            setEmail(event.target.value, );
        } else if (event.target.name === "password") {
            setPassword(event.target.value);
        }
    }

    useEffect(() => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const test = re.test(String(email).toLowerCase());
        if (test !== buttonActivated) {
            setButtonActivated(!buttonActivated);
        }
    }, [email])

    return (
        <div style={{ height: '100vh' }}>
            <Navbar bg="dark" variant="dark" className="d-flex justify-content-between flex-column flex-sm-row">
                <Link to="/">
                    <div className="d-flex flex-column text-white ml-sm-4 ml-1 mb-sm-0 mb-3  text-center text-sm-left">
                        <h3>Grande Mosquée de Clermont-Auvergne</h3>
                        {/*<h3>Conseil Régional du Culte Musulman d'Auvergne</h3>
                        <span>Calendrier des prières dans les Mosquées d'Auvergne</span>*/}
                    </div>
                </Link>
            </Navbar>
            <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "10%" }}>
                <Card>
                    <Card.Body>
                        <h3>Connexion Admin</h3>
                        <p>Renseignez vos identifiants administrateurs</p>
                        <Form>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control name="email" type="email" placeholder="Entrez email" onChange={handleChange}/>
                            </Form.Group>

                            <Form.Group controlId="formBasicPassword">
                                <Form.Label>Mot de passe</Form.Label>
                                <Form.Control name="password" type="password" placeholder="Mot de passe" onChange={handleChange} />
                            </Form.Group>
                            {error !== null ? <Alert variant="danger">
                                {error}
                            </Alert> : null}
                            <Button variant="success" onClick={handleSubmit} disabled={!buttonActivated}>
                                Se connecter
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default Login;